import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-bold text-white mb-4">
              星辰影院
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              星辰影院致力于为广大影迷提供最新、最全、最高清的电影资源。蓝光4K画质、流畅不缓冲的观影体验，让您足不出户享受影院级视听盛宴。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              电影分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  帮助中心
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-xs"></i>
                </span>
                contact@xingchencinema.com
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-xs"></i>
                </span>
                400-888-9999
              </li>
              <li className="flex items-start gap-2 text-sm text-background-400">
                <span className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs"></i>
                </span>
                北京市朝阳区影视产业园区A座
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-600/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024 星辰影院 XingChen Cinema. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            本站所有内容仅供学习交流，请勿用于商业用途
          </p>
        </div>
      </div>
    </footer>
  );
}